import React, {Component} from 'react';

import firebase from "./../firebase";
//import $ from 'jquery';
import './jquery.dataTables.min.css';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";

const $ = require('jquery');
$.DataTable = require('datatables.net');

export default class Logs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            role: '',
            count:0,
            datatable: [],
            count_logs: 0,
            myip: '',
            mylocation: '',
            logs: [],
            yourip:''
        };
    }

    componentDidMount() {
      //alert(localStorage.getItem('user_id'))
      this.getUser();
      this.getLogs();
      this.setdatatable();
    }

    //componentWillUnmount(){
    //  this.$el.DataTable.destroy(true);
    //}

    getUser = () => {
      //get(query(ref(db, 'Customers'), orderByChild('id'),equalTo(temp_id))).then((snapshot)=>{
      //get(query(ref(db, 'users'), orderByChild('email'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
      //get(ref(db, 'logs')).then((snapshot)=>{
      const db = getDatabase();
      get(query(ref(db, 'users'), orderByChild('email'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
        var userg = []
        snapshot.forEach(child => {
          var data = child.val()
        userg.push({
          id: data.key, 
          email: data.email,
          name: data.name,
          nickname: data.nickname,
          phone: data.phone,
          role: data.role,
          time: data.time
        })
        this.setState({ user: userg })
      })
        
      })
      setTimeout(function(){ 
        this.setState({ role: JSON.stringify(this.state.user[0].role) })
        //alert(JSON.stringify(this.state.role))
      //alert(JSON.stringify(this.state.user[0].role))   
      }.bind(this), 500);   
    }

    clearLogs = () => {
      const db = getDatabase();
      
      remove(ref(db,"logs"));
      setTimeout(function(){
        $('#datatable').DataTable().destroy();
        this.forceUpdate();
        this.getLogs();
        this.setdatatable();
        $('#datatable').show();
      }.bind(this), 300); 
    }

    setdatatable = () => {
      setTimeout(function(){
        this.$el = $(this.el)
        this.$el.DataTable({
          data: this.state.datatable,
          columns: [
            {"title": "ID","data": "id"},
            {"title": "Status","data": "status"},
            {"title": "Ip","data": "ip"},
            {"title": "Location","data": "location"},
            {"title": "Message","data": "message"},
            {"title": "User ID","data": "user_id"},
            {"title": "Browser Agent","data": "agent"},
            {"title": "Time","data": "time"},
          ],
          "order": [[ 0, "desc" ]]
        })
        }.bind(this), 1000); 
  }

    getLogs = () => {
      setTimeout(function(){ 
        if(this.state.user[0].role==='admin'){
        //alert(this.state.messages)
        const db = getDatabase();
        get(ref(db, 'logs')).then((snapshot)=>{
          let newChannels = []
          let newDatatable = []
          snapshot.forEach(child => {
            var channel = child.val()
            newChannels.push({ id: channel.id, agent: channel.agent, status: channel.status, ip: channel.ip, location: channel.location, message: channel.message, user_id: channel.user_id, time: channel.time })
            newDatatable.push({id: channel.id, agent: channel.agent, status: channel.status, ip: channel.ip, location: channel.location, message: channel.message, user_id: channel.user_id, time: channel.time })
          })

          this.setState({ logs: newChannels })
          this.setState({ datatable: newDatatable })

        })
        }

      }.bind(this), 500); 
      }

    render(){
        const divStyled={
            overflowY: 'scroll',
            border:'1px solid red',
            float: 'left',
            height:'162px',
            position:'relative',
            marginBottom: '30px'
          };
          const divStyle={
            overflowY: 'scroll',
            border:'1px solid red',
            float: 'left',
            height:'500px',
            position:'relative',
            marginBottom: '30px'
          };
          const divStyless={  
            height:'150px',
          };
        return (
            <main role="main" className="col-md-9 ml-sm-auto col-lg-12 pt-3 px-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
              <h1 className="h2">Logs Page</h1>
            </div>
            <p>Logs Page</p>
            <button onClick={((e) => this.clearLogs(e))} className="btn btn-primary mr-auto">Clear Logs</button>
            <table id="datatable" className="display" width="100%" ref={el => this.el = el }></table>

            <div style={divStyless}></div>
          </main>  
        )
    }
}